module.exports = __webpack_public_path__ + "img/ABX Express.90b183d5.png";